import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-semibold text-background-50">
                玫瑰视频
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed max-w-md">
              玫瑰视频聚合红桃视频、樱桃视频、茄子视频、糖心视频等多平台高清资源，免费在线观看不缓冲，最新电视剧全集和电影大全一网打尽，追剧观影首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/drama" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">电视剧</Link>
              <Link to="/category/action" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">动作片</Link>
              <Link to="/category/scifi" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">科幻片</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系方式
            </h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-background-50/60">
                <i className="ri-mail-line mr-2"></i>service@meiguivideo.com
              </span>
              <span className="text-sm text-background-50/60">
                <i className="ri-wechat-line mr-2"></i>玫瑰视频官方
              </span>
              <span className="text-sm text-background-50/60">
                <i className="ri-time-line mr-2"></i>9:00-21:00
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} 玫瑰视频 MeiguiVideo. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}